/**
 * API COVERAGE
 *   CompanySettingsController   GET/PUT /api/company-settings   → companySettingsApi.*
 *   BrandingSettingsController  GET/PUT /api/branding-settings  → brandingSettingsApi.*
 *   EmailSettingsController     GET/PUT /api/email-settings     → emailSettingsApi.*
 *   WhatsAppSettingsController  GET/PUT /api/whatsapp-settings  → whatsAppSettingsApi.*
 */
import { api } from '@/lib/apiClient';
import type {
  BrandingSettings,
  CompanySettings,
  EmailSettings,
  UpsertBrandingSettingsRequest,
  UpsertCompanySettingsRequest,
  UpsertEmailSettingsRequest,
  UpsertWhatsAppSettingsRequest,
  WhatsAppSettings,
} from '@/types/settings';

export const companySettingsApi = {
  get: () => api.get<CompanySettings>('/company-settings'),
  update: (body: UpsertCompanySettingsRequest) => api.put<CompanySettings>('/company-settings', body),
};

export const brandingSettingsApi = {
  get: () => api.get<BrandingSettings>('/branding-settings'),
  update: (body: UpsertBrandingSettingsRequest) =>
    api.put<BrandingSettings>('/branding-settings', body),
  /** PUT /api/branding-settings/login-template — the sign-in design on the company's own domain. */
  setLoginTemplate: (template: NonNullable<BrandingSettings['loginTemplate']>) =>
    api.put<BrandingSettings>('/branding-settings/login-template', { template }),
};

export const emailSettingsApi = {
  get: () => api.get<EmailSettings>('/email-settings'),
  update: (body: UpsertEmailSettingsRequest) => api.put<EmailSettings>('/email-settings', body),
};

export const whatsAppSettingsApi = {
  get: () => api.get<WhatsAppSettings>('/whatsapp-settings'),
  update: (body: UpsertWhatsAppSettingsRequest) =>
    api.put<WhatsAppSettings>('/whatsapp-settings', body),
};
